import React from 'react';

const CancellationPolicy = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-[#1b2d4a] text-white py-12">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold mb-2">
            CANCELLATION POLICY
          </h1>
          <p className="text-gray-300">
            Terms and conditions for service cancellation
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <ol className="list-decimal list-inside text-gray-700 space-y-6">
              <li className="leading-relaxed">
                No Refund/Cancellation/ Policy for Subscriptions
              </li>
              <li className="leading-relaxed">
                Once paid, registration fees are non-refundable. If a registrant desires to transfer his or her subscription, registration is transferable to another of its affiliates, subsidiaries, successors, or assigns ("The Reconnection", "we" or "us") so long as the registrant provides us with at least thirty (30) days written or electronic (emailed) notice of the desire to transfer the registration.
              </li>
              <li className="leading-relaxed">
                Sharing of our idea in other WhatsApp groups/social media channels is not permitted.
              </li>
              <li className="leading-relaxed">
                We reserve the right to cancel your subscription if we find out that you are sharing the login details or the stock ideas on any social media platforms.
              </li>
              <li className="leading-relaxed">
                By registering for our plan, you acknowledge that stock returns are never guaranteed as most of it depends on the stock market behavior.
              </li>
              <li className="leading-relaxed">
                Regardless of whether you execute the investment, once paid, the registration fee becomes non-refundable.
              </li>
              <li className="leading-relaxed">
                For any other queries please email us at <a href="mailto:info@climbcapital.in" className="text-blue-600 hover:underline">info@climbcapital.in</a>
              </li>
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CancellationPolicy;
